import styled, { css } from 'styled-components'

const designerCSS = css``

const developerCSS = css`
  .container {
    display: flex;
    flex-direction: column;
    margin: 15px 0 0 0;
  }
  .title {
    padding: 0 0 5px 0;
    font-size: 0.7rem;
    white-space: nowrap;
  }
  .title strong {
    font-weight: 600;
  }
  .track {
    position: relative;
    border: 1px solid #4f5356;
    display: grid;
    grid-template: ${({statesLength})=>`1fr/repeat(${statesLength}, 1fr)`};
    border-radius: 150px;
    overflow: hidden;
  }
  .stateOptionContainer {
    position: relative;
    z-index: 0;
    cursor: pointer;
  }
  .stateOption {
    /* text-transform: uppercase; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    padding: 8px 0 7px 0;
    width: 100%;
    font-weight: 500;
    color: #4f5356;
    font-size: .7rem;
  }

  .stateOption.active {
    font-weight: 500;
    color: #fff;
  }
  .stateOption.active_bg {
    position: absolute;
    top: 0;
    left: 0;
    color: white;
    background: #4f5356;
    height: 100%;
    z-index: -1;
  }
`

export const StateSliderCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
